module.exports = __webpack_public_path__ + "img/income-history.0bcaaa92.svg";